import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import {
  ButtonModule,
  PreventBubbleDirective,
  rotateAnimation,
} from '@lockton-apps/shared/ui/lui';
import { get } from 'lodash';
import { CellLabelPipe } from '../../../pipes/label.pipe';
import { DynamicTableComponent } from '../../table/dynamic-table.component';
import { DynamicTableColumnTemplate } from '../column-template.directive';

interface ExpandCellProps<Entity extends object> {
  label: string | ((entity: Entity) => string);
  canExpand?: (entity: Entity) => boolean;
}

@Component({
    selector: 'la-expand-cell',
    imports: [
        CommonModule,
        ButtonModule,
        MatIconModule,
        PreventBubbleDirective,
        CellLabelPipe,
    ],
    templateUrl: './expand-cell.component.html',
    styleUrls: ['./expand-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [rotateAnimation()]
})
export class ExpandCellComponent<
  Entity extends object
> extends DynamicTableColumnTemplate<ExpandCellProps<Entity>, Entity> {
  get isExpanded() {
    this.table.config.idPath;
    const selectedId = get(this.entity, this.table.config.idPath || 'id');
    return this.table.expandedElement === selectedId;
  }

  constructor(private table: DynamicTableComponent<Entity>) {
    super();
  }

  onToggle() {
    this.table.toggleExpandedRow(this.entity);
  }
}
